import React from 'react';
import styled from '@emotion/styled';
import CloseButton from './CloseButton';
import BackButton from './BackButton';
import { inIframe } from '../../helpers';
import KoalafiLogo from '../koalafiLogo/KoalafiLogo';
import ProgressBar from '../progress-bar';
import { isStoreHP } from '../../helpers/merchants/merchants';
import { SegmentProps } from '../../state-machine/actions/segment';
import { AppStatuses, Dealer } from '../../gql/graphql';

type IProps = SegmentProps & {
  orderId: string;
  goBackFunc: undefined | (() => void);
  currentNode: [string] | undefined;
  dealer: Dealer | undefined;
  highestSupportedApplicationMilestone: number;
  appStatus?: AppStatuses;
};

type StyleProps = {
  dealerId?: number;
};

const HeaderContainer = styled.div``;
const HeaderGradient = styled.div`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.06) 0%, rgba(0, 0, 0, 0) 100%);
  height: 12px;
  display: none;
`;

// Again, not great this is hardcoded, but only want to change padding for HP logo
const HeaderComponents = styled.div<StyleProps>`
  margin: ${(props: any) => {
    return isStoreHP(props.dealerId) ? '0px' : '0.8rem 0px 0.5rem 0px';
  }};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const ButtonPlaceholder = styled.div`
  display: flex;
  appearance: none;
  width: 48px;
  height: 48px;
`;

const Header: React.FC<IProps> = ({ orderId, goBackFunc, currentNode, dealer, track, page, identify, highestSupportedApplicationMilestone, appStatus }) => {
  return (
    <HeaderContainer>
      <HeaderGradient />
      <HeaderComponents dealerId={dealer?.id}>
        {goBackFunc ? <BackButton handleClick={goBackFunc} /> : <ButtonPlaceholder />}
        <KoalafiLogo dealerId={dealer?.id} />
        {inIframe() ? <CloseButton orderId={orderId} dealer={dealer} track={track} page={page} identify={identify} /> : <ButtonPlaceholder />}
      </HeaderComponents>
      <ProgressBar
        currentNode={currentNode}
        formType={dealer?.formType!}
        highestSupportedApplicationMilestone={highestSupportedApplicationMilestone}
        appStatus={appStatus}
      />
    </HeaderContainer>
  );
};

export default React.memo(Header);
